(() => {
  if (window.PrintMyPadUgcVideos) return;

  function init(scope = document) {
    scope.querySelectorAll("[data-ugc-carousel]").forEach((root) => {
      if (root.dataset.ugcInitialized === "true") return;

      const track = root.querySelector("[data-ugc-track]");
      const slides = Array.from(root.querySelectorAll("[data-ugc-slide]"));
      const videos = slides.map((slide) => slide.querySelector("[data-ugc-video]"));
      const prevBtn = root.querySelector('[data-ugc-nav="prev"]');
      const nextBtn = root.querySelector('[data-ugc-nav="next"]');
      const dotsContainer = root.querySelector("[data-ugc-dots]");
      const autoplayMobile = root.dataset.autoplayMobile === "true";
      const autoplayDesktop = root.dataset.autoplayDesktop === "true";

      let activeIndex = 0;
      let pendingPlayIndex = null;
      let scrollRaf = 0;
      let resizeRaf = 0;
      let isNearViewport = false;

      if (!track || slides.length === 0) return;
      root.dataset.ugcInitialized = "true";

      const isMobile = () => window.matchMedia("(max-width: 749px)").matches;
      const shouldAutoplay = () => (isMobile() ? autoplayMobile : autoplayDesktop);
      const canScroll = () => track.scrollWidth > track.clientWidth + 2;

      const safePlay = (video) => {
        if (!video) return;
        const promise = video.play();
        if (promise && promise.catch) promise.catch(() => {});
      };

      const prepareVideo = (video) => {
        if (!video || video.dataset.prepared === "true") return;
        video.dataset.prepared = "true";
        video.preload = "metadata";
        video.load();
      };

      const setMuteState = (button, muted) => {
        if (!button) return;
        button.classList.toggle("is-muted", muted);
        button.setAttribute("aria-pressed", muted ? "true" : "false");
      };

      const pauseAll = (except) => {
        videos.forEach((video) => {
          if (video && video !== except && !video.paused) video.pause();
        });
      };

      const playWithSound = (video, muteBtn) => {
        if (!video) return;
        pauseAll(video);
        prepareVideo(video);
        video.muted = false;
        setMuteState(muteBtn, false);
        safePlay(video);
      };

      const updateDots = () => {
        if (!dotsContainer) return;
        dotsContainer.querySelectorAll("[data-ugc-dot]").forEach((dot, index) => {
          dot.classList.toggle("is-active", index === activeIndex);
        });
      };

      const updateNav = () => {
        const scrollable = canScroll();
        if (prevBtn) prevBtn.disabled = !scrollable || activeIndex === 0;
        if (nextBtn) nextBtn.disabled = !scrollable || activeIndex === slides.length - 1;
      };

      const setActive = (index, options = {}) => {
        if (index < 0 || index >= slides.length) return;

        activeIndex = index;
        slides.forEach((slide, current) => {
          slide.classList.toggle("is-active", current === index);
        });

        updateDots();
        updateNav();

        const activeVideo = videos[index];
        const muteBtn = slides[index].querySelector("[data-ugc-mute]");

        if (activeVideo && (isNearViewport || options.userInitiated)) prepareVideo(activeVideo);

        if (pendingPlayIndex === index) {
          playWithSound(activeVideo, muteBtn);
          pendingPlayIndex = null;
          return;
        }

        if (isNearViewport && shouldAutoplay() && activeVideo && !options.userInitiated) {
          pauseAll(activeVideo);
          activeVideo.muted = true;
          setMuteState(muteBtn, true);
          safePlay(activeVideo);
        } else {
          pauseAll();
        }
      };

      const getClosestIndex = () => {
        const trackRect = track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const slideCenter = rect.left + rect.width / 2;
          const distance = Math.abs(center - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const scrollToIndex = (index, options = {}) => {
        const clamped = Math.max(0, Math.min(index, slides.length - 1));
        const slide = slides[clamped];
        if (!slide) return;

        if (!canScroll()) {
          setActive(clamped, { userInitiated: !!options.userInitiated });
          return;
        }

        const target = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
        track.scrollTo({ left: target, behavior: options.instant ? "auto" : "smooth" });

        if (options.playOnArrive) pendingPlayIndex = clamped;
        if (Math.abs(track.scrollLeft - target) < 2) {
          setActive(clamped, { userInitiated: !!options.userInitiated });
        }
      };

      if (dotsContainer) {
        dotsContainer.innerHTML = "";
        slides.forEach((_, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = root.dataset.dotClass || "ugc-video-dot";
          button.dataset.ugcDot = String(index);
          button.setAttribute("aria-label", `Go to video ${index + 1}`);
          button.addEventListener("click", () => {
            scrollToIndex(index, { userInitiated: true });
          });
          dotsContainer.appendChild(button);
        });
      }

      slides.forEach((slide, index) => {
        const video = videos[index];
        const playBtn = slide.querySelector("[data-ugc-play]");
        const muteBtn = slide.querySelector("[data-ugc-mute]");

        if (!video) return;

        const defaultMuted = video.dataset.defaultMuted !== "false";
        video.muted = defaultMuted;
        setMuteState(muteBtn, defaultMuted);

        const syncState = () => {
          slide.classList.toggle("is-playing", !video.paused);
        };

        const handlePlayIntent = () => {
          if (index !== activeIndex) {
            pendingPlayIndex = index;
            scrollToIndex(index, { playOnArrive: true, userInitiated: true });
            return;
          }

          if (video.paused) {
            playWithSound(video, muteBtn);
          } else {
            video.pause();
          }
        };

        playBtn?.addEventListener("click", (event) => {
          event.preventDefault();
          handlePlayIntent();
        });

        video.addEventListener("click", handlePlayIntent);
        video.addEventListener("play", syncState);
        video.addEventListener("pause", syncState);
        video.addEventListener("ended", syncState);

        muteBtn?.addEventListener("click", (event) => {
          event.preventDefault();
          video.muted = !video.muted;
          setMuteState(muteBtn, video.muted);
        });
      });

      track.addEventListener(
        "scroll",
        () => {
          if (!canScroll()) return;
          if (scrollRaf) cancelAnimationFrame(scrollRaf);
          scrollRaf = requestAnimationFrame(() => {
            const closestIndex = getClosestIndex();
            if (closestIndex !== activeIndex) setActive(closestIndex);
          });
        },
        { passive: true }
      );

      prevBtn?.addEventListener("click", () => scrollToIndex(activeIndex - 1, { userInitiated: true }));
      nextBtn?.addEventListener("click", () => scrollToIndex(activeIndex + 1, { userInitiated: true }));

      if (root._ugcResizeHandler) {
        window.removeEventListener("resize", root._ugcResizeHandler);
      }

      root._ugcResizeHandler = () => {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(() => {
          scrollToIndex(activeIndex, { instant: true });
        });
      };

      window.addEventListener("resize", root._ugcResizeHandler);

      const updateViewportState = (entries) => {
        const entry = entries[0];
        isNearViewport = entry ? entry.isIntersecting : true;

        if (isNearViewport) {
          setActive(activeIndex);
        } else {
          pauseAll();
        }
      };

      if ("IntersectionObserver" in window) {
        root._ugcViewportObserver = new IntersectionObserver(updateViewportState, {
          rootMargin: "200px 0px",
          threshold: 0.01,
        });
        root._ugcViewportObserver.observe(root);
      } else {
        isNearViewport = true;
        requestAnimationFrame(() => setActive(getClosestIndex()));
      }

      requestAnimationFrame(() => {
        activeIndex = getClosestIndex();
        if (isNearViewport) {
          setActive(activeIndex);
        } else {
          updateDots();
          updateNav();
        }
      });
    });
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:block:select", (event) => init(event.target));

  window.PrintMyPadUgcVideos = { init };
  init();
})();
